import { IDepartmentHierarchy, ISupervisor } from "@/Settings/types/SystemSettings/washoutReviewers";

const searchSupervisor = (supervisor: ISupervisor, position: string): string[] | null => {
	const positions = Array.isArray(supervisor.positions) ? supervisor.positions : [supervisor.positions];
	if (positions.includes(position)) {
		return supervisor.supervisor ? getSupervisorPositions(supervisor.supervisor) : [];
	}
	if (supervisor.supervisor) {
		return searchSupervisor(supervisor.supervisor, position);
	}
	return null;
};

const getSupervisorPositions = (supervisor: ISupervisor): string[] => {
	const positionsArray = Array.isArray(supervisor.positions) ? supervisor.positions : [supervisor.positions];
	if (supervisor.supervisor) {
		return positionsArray.concat(getSupervisorPositions(supervisor.supervisor));
	}
	return positionsArray;
};

const findSupervisorPositions = (position: string, hierarchy: IDepartmentHierarchy): string[] => {
	for (const pos of hierarchy.path.positions) {
		if (pos === position) {
			return getSupervisorPositions(hierarchy.path.supervisor);
		}
	}
	return searchSupervisor(hierarchy.path.supervisor, position) || [];
};

export const filteredFindSupervisorPositions = (position: string, hierarchy?: IDepartmentHierarchy) => {
	if (!hierarchy) {
		return [];
	}
	const splitPosition = position.split(" ");
	const lastPositionPart = splitPosition.pop() ?? "";
	const supervisorPositions = findSupervisorPositions(position, hierarchy);
	if (lastPositionPart === "New") {
		return supervisorPositions.filter((pos) => !pos.includes("Pre-owned"));
	}
	if (lastPositionPart === "Pre-owned") {
		return supervisorPositions.filter((pos) => !pos.includes("New"));
	}
	return supervisorPositions;
};
